export const StorageKeys = {
    VERIFICATION: 'verification_state',
  } as const
  
  export const StorageUtils = {
    setVerificationState: (state: {
      email: string;
      isVerified: boolean;
      timestamp: number;
    }) => {
      localStorage.setItem(StorageKeys.VERIFICATION, JSON.stringify(state))
    },
  
    getVerificationState: () => {
      const state = localStorage.getItem(StorageKeys.VERIFICATION)
      if (!state) return null
      
      try {
        const parsedState = JSON.parse(state)
        const isExpired = Date.now() - parsedState.timestamp > 24 * 60 * 60 * 1000
        if (isExpired) {
          localStorage.removeItem(StorageKeys.VERIFICATION)
          return null
        }
        
        return parsedState
      } catch {
        return null
      }
    },
  
    clearVerificationState: () => {
      localStorage.removeItem(StorageKeys.VERIFICATION)
    }
  }